import { useAccountSelf, useSelf } from 'App/components/hooks/appHooks';
import { Feature, useFeatureAvailable } from 'App/components/hooks/featureHelper';
import { hasAiWorkspaceLicence } from 'App/shadcn/pages/ProspectingTools/access';

const useAiPromptsAccess = () => {
	const isAdmin = !!useSelf()?.administrator;
	const hasAiFeature = useFeatureAvailable(Feature.AI);
	const hasAiLicence = hasAiWorkspaceLicence(useAccountSelf());
	const hasNotetaker = useFeatureAvailable(Feature.AI_MEETING_NOTETAKER);
	const hasContactScraper = useFeatureAvailable(Feature.AI_CONTACT_SCRAPER);
	const hasPreMeetingResearch = useFeatureAvailable(Feature.AI_PRE_MEETING_RESEARCH);

	return isAdmin && (hasAiFeature || hasAiLicence || hasNotetaker || hasContactScraper || hasPreMeetingResearch);
};

export default useAiPromptsAccess;
